import { Component, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import dayjs from 'dayjs';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';
import { RouterLink } from '@angular/router';
import { NotificationsService } from '../../services/notifications.service';
import { CurrentUserService } from '../../services/current-user.service';
import { SearchInputComponent } from '../../framework/search-input/search-input.component';
import { UsersDataSource } from './users.datasource';
import { FloatingInputComponent } from '@app/framework/inputs/floating-input/floating-input.component';
import { TooltipDirective } from '@app/directives/tooltip.directive';
import { SimpleButtonComponent } from '@app/framework/buttons/simple-medium-button/simple-button.component';

/**
 * Be aware, this component is barely maintained.  <br/>
 * It is created to show all users and manage them. It is only visible to admin users.
 */
@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss'],
  imports: [
    CommonModule,
    MatButton,
    MatTooltip,
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    ReactiveFormsModule,
    CdkFixedSizeVirtualScroll,
    SearchInputComponent,
    FloatingInputComponent,
    TooltipDirective,
    SimpleButtonComponent,
    RouterLink,
  ],
})
export class AdminPanelComponent implements OnInit {
  users: any = [];
  statusMessage = 'No users to show';
  editId = null;
  dayjs = dayjs;

  userForm = new UntypedFormGroup({
    company_name: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    first_name: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    last_name: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10)]),
    password: new UntypedFormControl('', [Validators.minLength(8)]),
  });
  searchText = '';

  constructor(
    private user: CurrentUserService,
    private notif: NotificationsService,
  ) {
    // this.users = new UsersDataSource(user, notif);
  }

  ngOnInit(): void {
    this.statusMessage = 'Loading...';
    this.users = new UsersDataSource(this.user, this.notif);

    // this.users = [];
    //
    // this.user.getAllUsers().then(
    //   (data: any) => {
    //     this.users = data.data; // data.filter(u => u.status < 2).reverse();
    //     this.statusMessage = 'No new users';
    //   },
    //   err => {
    //     this.statusMessage = err;
    //   }
    // );
  }

  test(ms): Promise<any> {
    return new Promise<any>((res) => {
      setTimeout(() => {
        res(true);
      }, ms);
    });
  }

  acceptUser(item: any) {
    this.user.acceptUser(item).then(
      (data) => {
        this.notif.showSuccess('User accepted!');
        this.registerSearch(this.searchText);
      },
      (err) => {
        this.statusMessage = err;
        this.users = [];
      },
    );
  }

  deleteUser(item: any) {
    this.user.deleteUser(item).then(
      (data) => {
        this.ngOnInit();
      },
      (err) => {
        this.statusMessage = err;
        this.users = [];
      },
    );
  }

  editUser(item: any) {
    this.editId = item.id;
    this.userForm.get('company_name').setValue(item.company_name);
    this.userForm.get('last_name').setValue(item.last_name);
    this.userForm.get('first_name').setValue(item.first_name);
    this.userForm.get('phone').setValue(item.phone);
    this.userForm.get('email').setValue(item.email);
  }

  saveUser(item: any) {
    const body = this.userForm.getRawValue();

    if (body.password === '' || body.password === null) {
      delete body.password;
    } else {
      body.password_confirmation = body.password;
    }

    this.user.updateUserById(item.id, body).then(
      (data) => {
        this.users.updateUser(this.editId, body);
        this.editId = null;
        this.notif.showSuccess('User updated!');
      },
      (err) => {
        this.notif.showError(err.message);
      },
    );
  }

  registerSearch(event: any) {
    this.searchText = event;
    if (event == null) {
      this.users.searchPage('');
    } else {
      this.users.searchPage(this.searchText);
    }
  }

  verifyEmail(item: any) {
    const body = { verify_email: true };

    this.user.updateUserById(item.id, body).then(
      (_) => {
        this.notif.showSuccess('Email verified!');
        this.registerSearch(this.searchText);
      },
      (err) => {
        this.notif.showError(err.message);
      },
    );
  }
}
